import { React, useEffect, useState } from 'react';
import apiService from '../../services/apiServices';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import { Link } from 'react-router-dom';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { Bars } from 'react-loader-spinner'

const TemplateList = () => {
    const [templates, setTemplates] = useState([]);
    const [modal, setModal] = useState({});
    const [rowId, setRowId] = useState({});
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loader, setLoader] = useState(true);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getItems = () => {
        apiService().get('contractsTemplates')
            .then(response => {
                if(response.success){
                    setTemplates(response.data)
                    setLoader(false)
                }
            })
    }

    const handleDelete = (id) => {
        apiService().delete('contractsTemplates', id)
            .then((response) => {
                console.log(response)
                if (response) {
                    setModal({ open: false });
                    setToast({
                        open: true,
                        message: 'U fshi me sukses!',
                        variant: 'success',
                    });
                    setTemplates(templates.filter((worker) => worker.Id !== id));
                } else {
                    setModal({ open: false });
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
        });
    };

    const openModal = (id) => {
        setModal({
            open: true,
            tittle: 'Delete',
            message: 'Do you want to delete this row?',
        });
        setToast({ open: false });
        setRowId(id);
    };

    useEffect(() => {
        getItems()
    }, [])
    


    return (
        <div>
        {loader && <div className="loader-class"><Bars
        height="70"
        width="100%"
        color="#1976d2"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      /></div>}
        {!loader && <>
            <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
            <Toast {...toast} />
            <TopActions
            newHref="/contracts-templates/addtemplate"
            saveHref="/dashboard/"
            saveVisible="d-none"
            />
            <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                <TableRow>
                    <TableCell>Nr</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell style={{width: '50px'}}></TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {templates
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((w, index) => (
                    <TableRow key={w.Id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{w.Name}</TableCell>
                        <TableCell>
                            <ButtonGroup size="small">
                                <Link to={`contracts-templates/edittemplate/${w.Id}`}>
                                    <Button>
                                        <EditIcon />
                                    </Button>
                                </Link>
                                <Button onClick={() => openModal(w.Id)}>
                                    <DeleteIcon />
                                </Button>
                            </ButtonGroup>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={templates.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>}
        </div>
    )
}

export default TemplateList